var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',[_c('span',{staticClass:"logo"},[_vm._v("朗新科技")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.toLogin}},[_vm._v("去登录")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.toRegister}},[_vm._v("去注册")])],1),_c('el-main',{domProps:{"innerHTML":_vm._s(_vm.textHtml)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }